import { start } from "repl";
import { userId } from "../Contexts/LocaleContext";
import { ApiUtility } from "./ApiUtility";

class HomeServices {
  route = "/posts";
  homeRoute = "/api/settings/homepage?lang=";
  messageRoute = "/api/messages?lang=";
  messageIdRoute = "/api/articles/";
  allauthorRoute = "/api/Authors/5bbc60101fd2d735b0087d36?lang=";
  contactRoute = "/api/Settings/contactus";
  magzines = "/api/magazines?start="

  getHomeData = (lang: string, userid: string) => {
    return ApiUtility.get(
      this.homeRoute +
      lang +
      "&userid=" +
      localStorage.getItem("userId")
    );
  };

  getmagzine = (start: any, length: any) => {
    return ApiUtility.get(
      this.magzines + start + "&length=" + length
    )
  }

  getMessage = (lang: string, start: number, length: number) => {
    return ApiUtility.get(
      this.messageRoute +
      "&lang" +
      lang +
      "$start" +
      start +
      "&length=" +
      length
    );
  };

  getMessageId = (id: string, lang: string) => {
    return ApiUtility.get(this.messageIdRoute + id + "?lang=" + lang);
  };

  postcontact = (params: any) => {
    return ApiUtility.post(this.contactRoute, params);
  };

  sendFeedback = (
    name: string,
    phoneNumber: string,
    email: string,
    feedbacktype: string,
    comment: string
  ) => {
    if (!feedbacktype) {
      feedbacktype = "1";
    }
    return ApiUtility.post(
      this.contactRoute,
      {
        contactType: feedbacktype,
        name: name,
        phoneNumber: phoneNumber,
        email: email,
        userId: userId,
        messageContent: comment,
        medium: "1",
      },

    );
  }
}
export default new HomeServices();
